import { GISCreditTypes } from './gis';
import { SortItem, sortTypes, sortDirection } from '../ss-api/responses/member.dashboard.license.response';

export interface IGISBundleLogItem  {
    ID: number;
    MemberID: number;
    ServiceID: number;
    ProductID: number;
    PromoID: number;
    Description: string;
    BundleCredits: number;
    UsedCredits: number;
    CreditType: GISCreditTypes;
    PurchaseDate: Date;
    ExpirationDate: Date;
    IsExpired: boolean;
    Processed: boolean;
    Refunded: boolean;
    DateTimeRefunded: Date;
    HasNotes: boolean;
    DateTimeEffective: Date;
    LicenseKey: string;

}

export class GISBundleLogItem implements IGISBundleLogItem {
    ID: number;
    MemberID: number;
    ServiceID: number;
    ProductID: number;
    PromoID: number;
    Description: string;
    BundleCredits: number;
    UsedCredits: number;
    CreditType: GISCreditTypes;
    PurchaseDate: Date;
    ExpirationDate: Date;
    DateTimeEffective: Date;
    LicenseKey: string;
    IsExpired: boolean;
    Processed: boolean;
    Refunded: boolean;
    DateTimeRefunded: Date;
    HasNotes: boolean;

}


export class GISBundleLogArray extends Array<GISBundleLogItem> {

    public LastSort = new SortItem;

    constructor(...items: GISBundleLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GISBundleLogArray.prototype);
    }

    public static checkVariables(checkThis: GISBundleLogArray) {
        if ( checkThis.LastSort == undefined ) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

    
    public static sortByStartDate( sortThis: GISBundleLogArray, direction: sortDirection = sortDirection.NotSpecified ): GISBundleLogArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.GISBundleStartDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.DateTimeEffective < a.DateTimeEffective) return -1;
                else if (b.DateTimeEffective > a.DateTimeEffective) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.DateTimeEffective < b.DateTimeEffective) return -1;
                else if (a.DateTimeEffective > b.DateTimeEffective) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.GISBundleStartDate;
        return sortThis;
    }


    public static sortByPurchaseDate( sortThis: GISBundleLogArray, direction: sortDirection = sortDirection.NotSpecified ): GISBundleLogArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.GISBundlePurchaseDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.PurchaseDate < a.PurchaseDate) return -1;
                else if (b.PurchaseDate > a.PurchaseDate) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.PurchaseDate < b.PurchaseDate) return -1;
                else if (a.PurchaseDate > b.PurchaseDate) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.GISBundlePurchaseDate;
        return sortThis;
    }

    public static sortByExpireDate( sortThis: GISBundleLogArray, direction: sortDirection = sortDirection.NotSpecified ): GISBundleLogArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.GISBundleExpireDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                if (b.ExpirationDate < a.ExpirationDate) return -1;
                else if (b.ExpirationDate > a.ExpirationDate) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                if (a.ExpirationDate < b.ExpirationDate) return -1;
                else if (a.ExpirationDate > b.ExpirationDate) return 1;
                else return 0;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.GISBundleExpireDate;
        return sortThis;
    }

}
